(function () {
  const TOOLBAR = '[data-collection-toolbar]';
  const FORM = '[data-collection-toolbar-form]';
  const DROPDOWN = '[data-toolbar-dropdown]';
  const TOGGLE = '[data-toolbar-toggle]';
  const COMPACT = '[data-toolbar-compact]';
  const GRID = '[data-products-grid]';
  const PRICE_INPUT = '[data-toolbar-price]';
  const FILTER_INPUT = '[data-toolbar-filter]';
  const SORT_OPTION = '[data-toolbar-sort]';
  const SORT_INPUT = '[data-toolbar-sort-input]';
  const OPEN_CLASS = 'is-open';
  const COMPACT_QUERY = '(max-width: 1023px)';

  function toolbarRoot() {
    return document.querySelector(TOOLBAR);
  }

  function isCompact() {
    return window.matchMedia(COMPACT_QUERY).matches;
  }

  function closeDropdowns(except) {
    document.querySelectorAll(DROPDOWN).forEach((dropdown) => {
      if (dropdown === except) return;
      dropdown.classList.remove(OPEN_CLASS);
      const toggle = dropdown.querySelector(TOGGLE);
      const panel = dropdown.querySelector('.collection-toolbar__panel');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  function setPanePanels(form, paneName, visible) {
    const pane = form.querySelector(`[data-toolbar-pane="${paneName}"]`);
    if (!pane) return;
    pane.querySelectorAll('.collection-toolbar__panel').forEach((panel) => {
      panel.hidden = !visible;
    });
  }

  function closeCompact(form) {
    if (!form) return;
    form.classList.remove('is-filters-open', 'is-sort-open');
    form.querySelectorAll(COMPACT).forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
    setPanePanels(form, 'filters', false);
    setPanePanels(form, 'sort', false);
  }

  function toggleCompact(form, which) {
    const openClass = which === 'filters' ? 'is-filters-open' : 'is-sort-open';
    const willOpen = !form.classList.contains(openClass);
    closeDropdowns();
    closeCompact(form);
    if (!willOpen) return;

    form.classList.add(openClass);
    const button = form.querySelector(`${COMPACT}[data-toolbar-compact="${which}"]`);
    if (button) button.setAttribute('aria-expanded', 'true');
    setPanePanels(form, which, true);
  }

  function toggleDropdown(dropdown) {
    const willOpen = !dropdown.classList.contains(OPEN_CLASS);
    closeDropdowns(willOpen ? dropdown : null);
    dropdown.classList.toggle(OPEN_CLASS, willOpen);
    const toggle = dropdown.querySelector(TOGGLE);
    const panel = dropdown.querySelector('.collection-toolbar__panel');
    if (toggle) toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (panel) panel.hidden = !willOpen;
  }

  function isAvailabilityInput(input) {
    if (!input) return false;
    if (input.hasAttribute('data-toolbar-stock')) return true;
    if (!input.name) return false;
    const name = String(input.name).toLowerCase();
    if (name.indexOf('availability') !== -1) return true;
    const label = (input.closest('label') && input.closest('label').textContent) || '';
    const text = label.toLowerCase();
    return (
      text.indexOf('in stock') !== -1 ||
      text.indexOf('out of stock') !== -1 ||
      text.indexOf('availability') !== -1
    );
  }

  function stockModeFromValue(input) {
    const dataMode = input.getAttribute('data-toolbar-stock');
    if (dataMode === 'in' || dataMode === 'out') return dataMode;
    const value = String(input.value || '');
    const label = ((input.closest('label') && input.closest('label').textContent) || '').toLowerCase();
    if (value === '1') return 'in';
    if (value === '0') return 'out';
    if (label.indexOf('out of stock') !== -1) return 'out';
    if (label.indexOf('in stock') !== -1) return 'in';
    return null;
  }

  function readStockModeFromUrl() {
    return new URLSearchParams(window.location.search).get('theme_stock') || null;
  }

  function readStockModeFromForm(form) {
    if (!form) return null;
    const checked = Array.from(form.querySelectorAll('input[data-toolbar-filter]:checked')).filter(
      isAvailabilityInput
    );
    if (!checked.length) return null;

    const modes = checked.map(stockModeFromValue).filter(Boolean);
    if (modes.indexOf('in') !== -1 && modes.indexOf('out') === -1) return 'in';
    if (modes.indexOf('out') !== -1 && modes.indexOf('in') === -1) return 'out';
    return null;
  }

  // Form is source of truth when submitting. Do not fall back to URL —
  // otherwise unchecking the box keeps theme_stock forever.
  function readStockMode(form) {
    if (form) return readStockModeFromForm(form);
    return readStockModeFromUrl();
  }

  function syncStockCheckboxes(form) {
    if (!form) return;
    const mode = readStockModeFromUrl();
    let availabilityFilter = null;

    form.querySelectorAll('input[data-toolbar-filter]').forEach((input) => {
      if (!isAvailabilityInput(input)) return;
      const inputMode = stockModeFromValue(input);
      const shouldCheck = Boolean(mode && inputMode === mode);
      input.checked = shouldCheck;
      input.removeAttribute('disabled');
      const option = input.closest('.collection-toolbar__option');
      if (option) option.classList.toggle('is-disabled', false);
      if (!availabilityFilter) {
        availabilityFilter = input.closest('[data-toolbar-dropdown]');
      }
    });

    if (!availabilityFilter) return;

    const activeCount = mode ? 1 : 0;
    availabilityFilter.classList.toggle('is-active', activeCount > 0);
    const trigger = availabilityFilter.querySelector('[data-toolbar-toggle]');
    if (!trigger) return;

    let badge = trigger.querySelector('.collection-toolbar__count');
    if (activeCount > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'collection-toolbar__count';
        const label = trigger.querySelector('span');
        if (label && label.nextSibling) trigger.insertBefore(badge, label.nextSibling);
        else trigger.appendChild(badge);
      }
      badge.textContent = String(activeCount);
    } else if (badge) {
      badge.remove();
    }
  }

  function applyThemeStockParam(params, form) {
    // Drop Shopify availability — it ignores out-of-stock tags used by the theme.
    const keys = Array.from(params.keys());
    keys.forEach((key) => {
      if (String(key).toLowerCase().indexOf('availability') !== -1) {
        params.delete(key);
      }
    });

    const mode = readStockModeFromForm(form);
    if (mode === 'in' || mode === 'out') params.set('theme_stock', mode);
    else params.delete('theme_stock');

    return params;
  }

  function collectParams(form) {
    const params = new URLSearchParams();
    const data = new FormData(form);

    data.forEach((value, key) => {
      if (value === '' || value == null) return;
      // Omit default sort so collection keeps its original order (bestsellers pin).
      if (key === 'sort_by' && (value === 'best-selling' || value === 'manual')) {
        return;
      }
      if (key === 'sort_by') {
        params.set(key, value);
        return;
      }
      // Do not send Shopify price params — they use shop currency, not card prices.
      if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') return;
      params.append(key, value);
    });

    return applyThemeStockParam(params, form);
  }

  function updateResultsCount(count) {
    const label = document.querySelector('[data-results-count]');
    if (!label) return;
    const safeCount = Math.max(0, Number(count) || 0);
    label.textContent = safeCount === 1 ? '1 product' : `${safeCount} products`;
    label.setAttribute('data-count', String(safeCount));
  }

  function applyClientStockFilter(form) {
    // Prefer checked boxes; fall back to URL after a fresh AJAX paint
    const mode = readStockModeFromForm(form) || readStockModeFromUrl();
    const grid =
      document.querySelector('#CollectionLoop') ||
      document.querySelector(`${GRID} .grid`);
    if (!grid) return;

    const cards = Array.from(grid.children).filter(
      (el) => el.classList && el.classList.contains('product_item')
    );
    let visible = 0;

    cards.forEach((card) => {
      const soldOut = card.classList.contains('product_item--sold-out');
      let show = true;
      if (mode === 'in') show = !soldOut;
      if (mode === 'out') show = soldOut;
      card.hidden = !show;
      card.style.display = show ? '' : 'none';
      if (show) visible += 1;
    });

    updateResultsCount(visible);
    return visible;
  }

  function collectionProductCards() {
    const grid =
      document.querySelector('#CollectionLoop') ||
      document.querySelector(`${GRID} .grid`) ||
      document.querySelector(GRID);
    if (!grid) return [];
    return Array.from(grid.querySelectorAll('.product_item[data-sort-price]'));
  }

  function syncPriceFilterMaxFromVisible() {
    const maxUnits = 99;
    const toolbar = toolbarRoot();
    if (toolbar) toolbar.setAttribute('data-theme-price-max-cents', String(maxUnits * 100));

    document.querySelectorAll(PRICE_INPUT).forEach((input) => {
      input.max = String(maxUnits);
      if (input.name === 'theme_price_max' && !input.value) {
        input.placeholder = '99+';
      }
    });
  }

  /* PRICE MAX DYNAMIC START
  function visiblePriceMaxCents() {
    let maxCents = 0;
    let sawCard = false;

    collectionProductCards().forEach((el) => {
      if (el.classList.contains('product_item--sold-out')) return;
      sawCard = true;
      maxCents = Math.max(maxCents, Number(el.getAttribute('data-sort-price')) || 0);
    });

    if (sawCard) return maxCents;

    const toolbar = toolbarRoot();
    if (toolbar) return Number(toolbar.getAttribute('data-theme-price-max-cents')) || 0;
    return 0;
  }

  function syncPriceFilterMaxFromVisibleDynamic() {
    const maxCents = visiblePriceMaxCents();
    if (maxCents <= 0) return;

    const maxUnits = Math.ceil(maxCents / 100);
    const toolbar = toolbarRoot();
    if (toolbar) toolbar.setAttribute('data-theme-price-max-cents', String(maxCents));

    document.querySelectorAll(PRICE_INPUT).forEach((input) => {
      input.max = String(maxUnits);
      if (input.name === 'theme_price_max' && !input.value) {
        input.placeholder = String(maxUnits);
      }
    });
  }
  PRICE MAX DYNAMIC END */

  function priceBoundCents(raw) {
    if (raw == null || raw === '') return null;
    const amount = parseFloat(String(raw).replace(',', '.'));
    if (Number.isNaN(amount)) return null;
    return Math.round(amount * 100);
  }

  function syncPriceInputsFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const min = params.get('theme_price_min');
    const max = params.get('theme_price_max');

    document.querySelectorAll(PRICE_INPUT).forEach((input) => {
      if (input.name === 'theme_price_min') {
        input.value = min != null && min !== '' ? min : '';
      }
      if (input.name === 'theme_price_max') {
        input.value = max != null && max !== '' ? max : '';
      }
    });
  }

  function applyClientPriceFilter() {
    const params = new URLSearchParams(window.location.search);
    const minCents = priceBoundCents(params.get('theme_price_min'));
    const maxCents = priceBoundCents(params.get('theme_price_max'));
    if (minCents == null && maxCents == null) return;

    const cards = collectionProductCards();
    let visible = 0;

    cards.forEach((card) => {
      if (card.hidden || card.style.display === 'none') return;
      const price = Number(card.getAttribute('data-sort-price')) || 0;
      const show =
        (minCents == null || price >= minCents) && (maxCents == null || price <= maxCents);
      card.hidden = !show;
      card.style.display = show ? '' : 'none';
      if (show) visible += 1;
    });

    updateResultsCount(visible);
  }

  function sortGridByVisiblePrice(form) {
    const sortInput = form && form.querySelector(SORT_INPUT);
    const sortBy = sortInput ? sortInput.value : '';
    if (sortBy !== 'price-ascending' && sortBy !== 'price-descending') return;

    const grid =
      document.querySelector('#CollectionLoop') ||
      document.querySelector(`${GRID} .grid`);
    if (!grid) return;

    const items = Array.from(grid.children).filter(
      (el) => el.classList && el.classList.contains('product_item') && el.hasAttribute('data-sort-price')
    );
    if (items.length < 2) return;

    const ascending = sortBy === 'price-ascending';
    items.sort((a, b) => {
      const priceA = Number(a.getAttribute('data-sort-price')) || 0;
      const priceB = Number(b.getAttribute('data-sort-price')) || 0;
      return ascending ? priceA - priceB : priceB - priceA;
    });
    items.forEach((item) => grid.appendChild(item));
  }

  function loadCollection(form, pathname, options) {
    const settings = options || {};
    const keepParams = settings.keepParams !== false;
    const push = settings.push !== false;
    const openPane = form.classList.contains('is-filters-open')
      ? 'filters'
      : form.classList.contains('is-sort-open')
        ? 'sort'
        : null;
    const params = collectParams(form);
    const query = params.toString();
    let url = pathname || window.location.pathname;
    if (keepParams) {
      const path = pathname || window.location.pathname;
      url = query ? `${path}?${query}` : path;
    }
    const grid = document.querySelector(GRID);

    if (grid) grid.classList.add('is-loading');

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextToolbar = doc.querySelector(TOOLBAR);
        const nextGrid = doc.querySelector(GRID);
        const currentToolbar = toolbarRoot();
        const currentGrid = document.querySelector(GRID);

        if (!nextToolbar || !nextGrid || !currentToolbar || !currentGrid) {
          window.location.assign(url);
          return;
        }

        currentToolbar.innerHTML = nextToolbar.innerHTML;
        currentToolbar.setAttribute(
          'data-theme-price-max-cents',
          nextToolbar.getAttribute('data-theme-price-max-cents') || '0'
        );
        currentGrid.innerHTML = nextGrid.innerHTML;

        const collectionRoot = currentGrid.closest('collection-component');
        if (collectionRoot) {
          collectionRoot.setAttribute('data-collection', url.split('?')[0]);
        }

        if (push) history.pushState({}, '', url);

        const nextForm = currentToolbar.querySelector(FORM);
        syncStockCheckboxes(nextForm);
        syncPriceInputsFromUrl();
        sortGridByVisiblePrice(nextForm);
        applyClientStockFilter(nextForm);
        applyClientPriceFilter();
        syncPriceFilterMaxFromVisible();
        if (openPane && nextForm && isCompact()) {
          toggleCompact(nextForm, openPane);
        }
      })
      .catch((error) => {
        console.log(error);
        window.location.assign(url);
      })
      .finally(() => {
        const currentGrid = document.querySelector(GRID);
        if (currentGrid) currentGrid.classList.remove('is-loading');
      });
  }

  let priceTimer;

  document.addEventListener('click', (event) => {
    const root = toolbarRoot();
    if (!root) return;

    const collectionLink = event.target.closest('[data-collection-url]');
    if (collectionLink && collectionLink.closest(TOOLBAR)) {
      event.preventDefault();
      const form = collectionLink.closest(TOOLBAR).querySelector(FORM);
      const path = collectionLink.getAttribute('data-collection-url');
      if (!form || !path) return;
      const currentPath = window.location.pathname.replace(/\/$/, '');
      const nextPath = path.replace(/\/$/, '').split('?')[0];
      if (currentPath === nextPath && window.location.search === '') return;
      loadCollection(form, path, { keepParams: false });
      return;
    }

    const compactButton = event.target.closest(COMPACT);
    if (compactButton && compactButton.closest(TOOLBAR)) {
      event.preventDefault();
      const form = compactButton.closest(FORM);
      const which = compactButton.getAttribute('data-toolbar-compact');
      if (form && which) toggleCompact(form, which);
      return;
    }

    const toggle = event.target.closest(TOGGLE);
    if (toggle && toggle.closest(TOOLBAR)) {
      if (isCompact()) return;
      event.preventDefault();
      const dropdown = toggle.closest(DROPDOWN);
      if (dropdown) toggleDropdown(dropdown);
      return;
    }

    const sortOption = event.target.closest(SORT_OPTION);
    if (sortOption && sortOption.closest(TOOLBAR)) {
      event.preventDefault();
      const form = sortOption.closest(FORM);
      const sortInput = form && form.querySelector(SORT_INPUT);
      if (sortInput) sortInput.value = sortOption.getAttribute('data-value') || 'best-selling';
      if (form) loadCollection(form);
      return;
    }

    if (
      !event.target.closest(DROPDOWN) &&
      !event.target.closest('[data-toolbar-pane]') &&
      !event.target.closest('.collection-toolbar__compact')
    ) {
      closeDropdowns();
      const form = root.querySelector(FORM);
      if (form) closeCompact(form);
    }
  });

  document.addEventListener('change', (event) => {
    if (!event.target.closest(TOOLBAR)) return;

    if (event.target.matches(FILTER_INPUT)) {
      const form = event.target.closest(FORM);
      if (!form) return;

      // In stock / Out of stock are alternatives for theme-side filtering
      if (isAvailabilityInput(event.target) && event.target.checked) {
        form.querySelectorAll('input[data-toolbar-filter]').forEach((input) => {
          if (input !== event.target && isAvailabilityInput(input)) input.checked = false;
        });
      }

      loadCollection(form);
    }
  });

  document.addEventListener('input', (event) => {
    if (!event.target.closest(TOOLBAR)) return;
    if (!event.target.matches(PRICE_INPUT)) return;

    const form = event.target.closest(FORM);
    window.clearTimeout(priceTimer);
    priceTimer = window.setTimeout(() => {
      if (form) loadCollection(form);
    }, 400);
  });

  const compactMedia = window.matchMedia(COMPACT_QUERY);
  const onCompactChange = (event) => {
    if (event.matches) return;
    const form = document.querySelector(FORM);
    closeDropdowns();
    closeCompact(form);
  };

  if (compactMedia.addEventListener) {
    compactMedia.addEventListener('change', onCompactChange);
  } else if (compactMedia.addListener) {
    compactMedia.addListener(onCompactChange);
  }

  window.addEventListener('popstate', () => {
    if (!toolbarRoot()) return;
    const form = document.querySelector(FORM);
    if (!form) return;
    loadCollection(form, window.location.pathname + window.location.search, {
      keepParams: false,
      push: false,
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector(FORM);
    if (!form || !toolbarRoot()) return;

    syncStockCheckboxes(form);
    syncPriceInputsFromUrl();
    sortGridByVisiblePrice(form);
    applyClientStockFilter(form);
    applyClientPriceFilter();
    syncPriceFilterMaxFromVisible();

    const current = new URLSearchParams(window.location.search);
    let changed = false;

    if (current.has('filter.v.price.gte') || current.has('filter.v.price.lte')) {
      const gte = current.get('filter.v.price.gte');
      const lte = current.get('filter.v.price.lte');
      current.delete('filter.v.price.gte');
      current.delete('filter.v.price.lte');
      if (gte && !current.get('theme_price_min')) current.set('theme_price_min', gte);
      if (lte && !current.get('theme_price_max')) current.set('theme_price_max', lte);
      changed = true;
    }

    const hasAvailability = Array.from(current.keys()).some(
      (key) => String(key).toLowerCase().indexOf('availability') !== -1
    );
    if (hasAvailability) {
      applyThemeStockParam(current, form);
      changed = true;
    }

    if (!changed) return;

    const query = current.toString();
    const url = query ? `${window.location.pathname}?${query}` : window.location.pathname;
    const currentUrl = window.location.pathname + window.location.search;
    if (url === currentUrl) return;

    history.replaceState({}, '', url);
    loadCollection(form, url, { keepParams: false, push: false });
  });
})();
